// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h0OaaCMtqg8rceql {
	white-space: pre;
	text-wrap: initial;
}

.AnNufeEJdo0hZAOT {
	max-width: 1070px;
	width: fit-content;
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/UserCreatedProfileModal/UserCreatedProfileModal.module.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB","sourcesContent":[".toast {\n\twhite-space: pre;\n\ttext-wrap: initial;\n}\n\n.modal {\n\tmax-width: 1070px;\n\twidth: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toast": `h0OaaCMtqg8rceql`,
	"modal": `AnNufeEJdo0hZAOT`
};
export default ___CSS_LOADER_EXPORT___;
